// extracted by mini-css-extract-plugin
module.exports = {"title":"RaceList-module--title--p5En9","wrapper":"RaceList-module--wrapper--2_t1j"};